const initialState = {
    loading: false,
    notificationChannel:[],
    preferenceData: {},
    updateStatus: null,
  error: null,
  successMessage: "",
  errorMessage: "",
  };
  
  const PreferenceReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_NOTIFICATION_LOADING":
        return {
          ...state,
          loading: true,
        };
      case "NOTIFICATION_DATA_SUCCESS":
        return {
          ...state,
          loading: false,
          notificationChannel:action.payload.notificationChannel,
          preferenceData: action.payload.preferenceData,
        };
        case "OVERRIDE_NOTIFICATION": {
          const index = action.payload;
          const prevChannels = state.notificationChannel || [];
        
          const newChannels = prevChannels.map((channel, i) =>
            i === index ? { ...channel, isActive: !channel.isActive } : channel
          );
        
          return {
            ...state,
            notificationChannel: newChannels,
          };
        }
        case "UPDATE_NOTIFICATION_LOADING":
          return {
            ...state,
            loading: true,
            updateStatus: null,
            error: null,
          };
          case "UPDATE_NOTIFICATION_SUCCESS":
      return {
        ...state,
        loading: false,
        updateStatus: action.payload,
          successMessage: action.payload,
        errorMessage: "",
      };
      case "UPDATE_NOTIFICATION_ERROR":
        return {
          ...state,
          loading: false,
          error: action.payload,
          updateStatus: null,
        };
  
      default:
        return state;
    }
  };
  
  export default PreferenceReducer;